// extracted by mini-css-extract-plugin
export var answer = "collapsableQuestion-module--answer--TwMjc";
export var collapseStatus = "collapsableQuestion-module--collapseStatus--euOs8";
export var question = "collapsableQuestion-module--question--H-2eW";
export var questionSection = "collapsableQuestion-module--questionSection--JD0nG";